export default {
  resources: {
    clients: {
      name: 'Cliente |||| Clientes',
    },
    courses: {
      name: 'Curso |||| Cursos',
    },
    units: {
      name: 'Unidad |||| Unidades',
    },
    licenses: {
      name: 'Licencia |||| Licencias',
    },
    scorms: {
      name: 'Scorm |||| Scorms',
    },
    students: {
      name: 'Estudiante |||| Estudiantes',
    },
    users: {
      name: 'Usuario |||| Usuarios',
    },
  },
  custom: {
    userMenu: {
      changeLang: 'Cambiar idioma',
    },
    dashboard: {
      title: 'Visión general',
    },
    clients: {
      title: 'Clientes',
      theme: 'Tema',
      coursesLength: 'Total cursos',
    },
    courses: {
      title: 'Cursos',
      titleSingular: 'Curso',
      unitsLength: 'Total unidades',
      clientName: 'Nombre cliente',
      licenseName: 'Nombre licencia',
      licenseStatus: 'Estado licencia',
      resource: 'El curso',
      updated: 'se ha actualizado correctamente',
      created: 'se ha creado correctamente',
    },
    licenses: {
      title: 'Licencias',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
    },
    scorms: {
      title: 'Scorms',
      titleSingular: 'Scorm',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      fichero: 'Fichero',
      fileName: 'Nombre del fichero',
      fileSize: 'Tamaño del fichero',
      filePath: 'Ruta del fichero',
    },
    general: {
      name: 'Nombre',
      loading: 'Cargando',
      createdAt: 'Fecha creación',
      status: 'Estado',
      updatedAt: 'Fecha modificación',
      generate: 'Generar',
    },
    students: {
      title: 'Estudiantes',
      platform: 'Plataforma',
      platformId: 'ID Plataforma',
    },
    units: {
      title: 'Unidades',
      courseName: 'Nombre curso',
      resource: 'La unidad',
      updated: 'se ha actualizado correctamente',
      created: 'se ha creado correctamente',
    },
    users: {
      title: 'Usuarios',
      username: 'Nombre usuario',
      email: 'Correo electrónico',
      role: 'Rol',
    },
    help: {
      title: 'Ayuda',
    },
    tour: {
      back: 'Atrás',
      close: 'Cerrar',
      last: 'Último',
      next: 'Siguiente',
      open: 'Abrir',
      skip: 'Saltar',
      tourClients: {
        screen1: {
          title: 'Gestión de clientes',
          text1: 'En esta pantalla se puede gestionar los distintos clientes.',
          text2:
            'Dependiendo de tu rol, podras editar, filtrar, crear o eliminar clientes.',
        },
        screen2: {
          title: 'Puedes reiniciar el tour',
          text1: 'Con este botón empieza de nuevo el tour',
        },
        screen3: {
          title: 'Paneles de gráficas',
          text1:
            'Aquí se mostrará la distinta información de las DSN. El primero que se muestra es "Visión General"',
        },
      },
    },
  },
};
